import './themePreloader'; // kick off theme chunk download before React mounts
import './translationsPreloader'; // kick off i18n loading before React mounts

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
